import { Predicates } from "../../../libraries/predicates/predicates";
import {
  PRODUCTION_STATUS_LABEL,
  SALES_STATUS_LABEL,
} from "../../../constants/labels";
import { CreateMpnState } from "../states/create/data";
import { checkComponentIsValid } from "../features/mpn-create/mpn-create.helper";

export const GET_MPN_PROCESS_CONDITIONS = {
  0: [
    {
      step: 0,
      condition: (state: CreateMpnState) => !!state.requestorInfo.id,
      message: `<strong>Requestor Location</strong> field is required`,
    },
  ],
  1: [
    {
      step: 1,
      condition: (state: CreateMpnState) =>
        Predicates.isNotNullAndNotUndefined(state.global_product),
      message: `<strong>Global Product or Item Number</strong> field is required`,
    },
  ],
  2: [
    {
      step: 1,
      condition: (state: CreateMpnState) =>
        Predicates.isNotNullAndNotUndefined(state.global_product),
      message: `<strong>Global Product or Item Number</strong> field is required`,
    },
  ],
  3: [   {
      step: 1,
      condition: (state: CreateMpnState) =>
        Predicates.isNotNullAndNotUndefined(state.global_product),
      message: `<strong>Global Product or Item Number</strong> field is required`,
    },
    {

      step: 3,
      condition: (state: CreateMpnState) =>
        state.composition.molded_components.every((component) =>
          checkComponentIsValid(component),
        ),
      message: `The <strong>Molded Components</strong> list have at least one invalid component`,
    },
    {
      step: 3,
      condition: (state: CreateMpnState) =>
        state.composition.non_molded_components.every((component) =>
          checkComponentIsValid(component),
        ),
      message: `The <strong>Non-Molded Components</strong> list have at least one invalid component`,
    },
  ],

  4: [
       {
      step: 1,
      condition: (state: CreateMpnState) =>
        Predicates.isNotNullAndNotUndefined(state.global_product),
      message: `<strong>Global Product or Item Number</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        state?.mpnData?.name?.trim().length > 0,
      message: `<strong>SKU Description</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        state?.mpnData?.product_use?.trim().length > 0,
      message: `<strong>Product Use</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        state.mpnData?.giftbox?.trim().length > 0,
      message: `<strong>Gift Box</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        state.mpnData?.reldt?.trim().length > 0,
      message: `<strong>Release Date</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        state.mpnData?.tps_product?.trim().length > 0,
      message: `<strong>TPS Product</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.tps_product === "Y" &&
          Predicates.isNotNullAndNotUndefined(state.mpnData?.tps_type_id) &&
          state.mpnData?.tps_type_id?.res_pis_type_id !== "0") ||
        state.mpnData?.tps_product === "N",
      message: `<strong>TPS Type</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.tps_product === "Y" &&
          Predicates.isNotNullAndNotUndefined(state.mpnData?.tps_loc_id) &&
          state.mpnData?.tps_loc_id.id !== "0") ||
        state.mpnData?.tps_product === "N",
      message: `<strong>Vendor</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        (state.fusionSupplier?.id ?? 0) > 0,
      message: `<strong>Fusion Supplier</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.production_lifecycle_status?.length ?? 0) > 0,
      message: `<strong>${PRODUCTION_STATUS_LABEL}</strong> field is required`,
    },
    {
      step: 4,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.sales_lifecycle_status?.length ?? 0) > 0,
      message: `<strong>${SALES_STATUS_LABEL}</strong> field is required`,
    },
  ],
  5: [
    {
      step: 5,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk?.trim().length > 0,
      message: `<strong>Standard Pack</strong> field is required`,
    },
    {
      step: 5,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_weight?.trim().length > 0,
      message: `<strong>Standard Pack Gross Weight (kg)</strong> field is required`,
    },
    {
      step: 5,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_length?.trim().length > 0,
      message: `<strong>Standard Pack Size L (mm)</strong> field is required`,
    },
    {
      step: 5,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_width?.trim().length > 0,
      message: `<strong>Standard Pack Size W (mm)</strong> field is required`,
    },
    {
      step: 5,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_height?.trim().length > 0,
      message: `<strong>Standard Pack Size H (mm)</strong> field is required`,
    },
  ],
  6: [
    {
      step: 7,
      condition: (state: CreateMpnState) => !!state.requestorInfo.id,
      message: `<strong>Requestor Location</strong> field is required`,
    },
    // {
    //   step: 7,
    //   condition: (state: CreateMpnState) =>
    //     Predicates.isNotNullAndNotUndefined(state.itemNumber),
    //   message: `<strong>Item Number</strong> field is required`,
    // },
    // {
    //   step: 7,
    //   condition: (state: CreateMpnState) =>
    //     Predicates.isNotNullAndNotUndefined(state.itemNumber),
    //   message: `<strong>Item Number</strong> field is required`,
    // },
    // {
    //   step: 7,
    //   condition: (state: CreateMpnState) =>
    //     state.composition.molded_components.every((component) =>
    //       checkComponentIsValid(component),
    //     ),
    //   message: `The <strong>Molded Components</strong> list have at least one invalid component`,
    // },
    // {
    //   step: 7,
    //   condition: (state: CreateMpnState) =>
    //     state.composition.non_molded_components.every((component) =>
    //       checkComponentIsValid(component),
    //     ),
    //   message: `The <strong>Non-Molded Components</strong> list have at least one invalid component`,
    // },
    // {
    //   step: 7,
    //   condition: (state: CreateMpnState) =>
    //     state.composition.non_molded_components.length > 0 ||
    //     state.composition.molded_components.length > 0 ||
    //     state.composition.mpns.length > 0,
    //   message: `The <strong>MPN</strong> list have at least one invalid component`,
    // },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state?.mpnData?.name?.trim().length > 0,
      message: `<strong>SKU Description</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state?.mpnData?.product_use?.trim().length > 0,
      message: `<strong>Product Use</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData?.giftbox?.trim().length > 0,
      message: `<strong>Gift Box</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData?.reldt?.trim().length > 0,
      message: `<strong>Release Date</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData?.tps_product?.trim().length > 0,
      message: `<strong>TPS Product</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.tps_product === "Y" &&
          Predicates.isNotNullAndNotUndefined(state.mpnData?.tps_type_id) &&
          state.mpnData?.tps_type_id?.res_pis_type_id !== "0") ||
        state.mpnData?.tps_product === "N",
      message: `<strong>TPS Type</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.tps_product === "Y" &&
          Predicates.isNotNullAndNotUndefined(state.mpnData?.tps_loc_id) &&
          state.mpnData?.tps_loc_id.id !== "0") ||
        state.mpnData?.tps_product === "N",
      message: `<strong>Vendor</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.production_lifecycle_status?.length ?? 0) > 0,
      message: `<strong>${PRODUCTION_STATUS_LABEL}</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        (state.mpnData?.sales_lifecycle_status?.length ?? 0) > 0,
      message: `<strong>${SALES_STATUS_LABEL}</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk?.trim().length > 0,
      message: `<strong>Standard Pack</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_weight?.trim().length > 0,
      message: `<strong>Standard Pack Gross Weight (kg)</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_length?.trim().length > 0,
      message: `<strong>Standard Pack Size L (mm)</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_width?.trim().length > 0,
      message: `<strong>Standard Pack Size W (mm)</strong> field is required`,
    },
    {
      step: 7,
      condition: (state: CreateMpnState) =>
        state.mpnData.stdpk_height?.trim().length > 0,
      message: `<strong>Standard Pack Size H (mm)</strong> field is required`,
    },
  ],
};
